jQuery(document).ready(function($) {

    jQuery(document).ready(function($) {

        $( ".bloc_photo_simple" ).each(function( index ) {

            var $bloc = $(this);
            var cibleParaPhoto = $bloc.find(".visuel")

            if(cibleParaPhoto.length){
                gsap.from( cibleParaPhoto , {
                    scale: 1.1,
                    scrollTrigger: {
                        trigger: cibleParaPhoto,
                        start: 'top 100%',
                        end: 'top 0%',
                        scrub: 1,
                        markers: false
                    }
                })
            }

        })

    });


});
